export function objectWithFallback<T extends Record<string, any>, F>(
  obj: T,
  fallback: F
): T & { [key: string]: T[keyof T] | F } {
  return new Proxy(obj, {
    get(target: T, property: string | symbol): T[keyof T] | F {
      if (typeof property === "string" && property in target) {
        return target[property as keyof T] || fallback;
      }
      return fallback;
    },
  }) as T & { [key: string]: T[keyof T] | F };
}
